module.exports = __webpack_public_path__ + "static/media/cvTime.247114cb.svg";